"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.partSupersededLabelOf = exports.RemedyPartSupersededIndicator = void 0;
var _react = _interopRequireDefault(require("react"));
var _materialSymbols = require("@design/icons/material-symbols");
var _RemedyActionPrimitives = require("@common/components/remedy/RemedyActionPrimitives");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var partSupersededLabelOf = exports.partSupersededLabelOf = function partSupersededLabelOf(partSupersededBy) {
  return "Applied \xB7 Part superseded by ".concat(partSupersededBy);
};
var RemedyPartSupersededIndicator = exports.RemedyPartSupersededIndicator = function RemedyPartSupersededIndicator(_ref) {
  var partSupersededBy = _ref.partSupersededBy;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex items-center gap-1 text-[11px] ".concat(_RemedyActionPrimitives.REMEDY_APPLIED_TEXT_CLASS, " font-medium"),
    "data-sentry-component": "RemedyPartSupersededIndicator",
    "data-sentry-source-file": "RemedyPartSupersededIndicator.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CheckIcon, {
      width: 14,
      height: 14,
      className: _RemedyActionPrimitives.REMEDY_APPLIED_TEXT_CLASS,
      "data-sentry-element": "CheckIcon",
      "data-sentry-source-file": "RemedyPartSupersededIndicator.tsx"
    }), partSupersededLabelOf(partSupersededBy)]
  });
};